module.exports = __webpack_public_path__ + "img/low-border.824ff6ee.png";